export default function byty2() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr align="center">
          <th colSpan={2}>
          </th>
          <th> present active part. </th>
          <td> suči </td>
        </tr>
        <tr align="center">
          <th> infinitive </th>
          <td> byti </td>
          <th> past active part. </th>
          <td> byvši </td>
        </tr>
        <tr align="center">
          <th>gerund </th>
          <td> bytje </td>
          <th> future active part. </th>
          <td> buduči </td>
        </tr>
      </tbody>
    </table>
  )
}
/* TODO - Чи релевантна ця структура? */
